import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Grazie, {{name}}',
    confirmation_email:
      "Riceverai a breve un'email di conferma con il numero d'ordine dal nostro partner tecnologico {{provider_email}}",
    need_help: 'Hai bisogno di aiuto?',
  },
  labels: {
    order_number: 'N. ordine: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Oggi',
    was_prefix: 'era',
    restaurant: 'Ristorante',
    order_details: 'Dettagli ordine',
    your_details: 'I tuoi dati',
    contact: 'Contatto',
    payment: 'Pagamento',
    payment_method: 'Metodo di pagamento',
    delivery: 'Consegna',
    delivery_details: 'Dettagli consegna',
    pickup_details: 'Dettagli ritiro',
    pickup_instruction: "📋 Comunica il numero d'ordine {{number}} al momento del ritiro.",
    billing_info: 'Informazioni di fatturazione',
    order_note: "Nota dell'ordine",
    order_summary: 'Riepilogo ordine',
    help: 'Hai bisogno di aiuto? Contattaci al {{phone_number}}',
  },
  status: {
    canceled: 'Ordine annullato',
    received: 'Ordine ricevuto',
    confirmed: 'Ordine confermato!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Ritiro',
    [ORDER_METHODS.DELIVERY]: 'Consegna',
    [ORDER_METHODS.ON_SITE]: 'Ordinazione al tavolo',
  },
  rewards: {
    member: {
      pill_title: 'Punti guadagnati',
      from_order: 'punti da questo ordine',
      total_balance: 'Saldo totale',
      reward_value: 'Valore premio',
      redeem_hint: '✓ Puoi riscattare fino a {{points}} pt ({{amount}}) sul tuo prossimo ordine',
      points_to_redeem: 'Ti mancano solo {{points}} punti per riscattare il tuo premio',
    },
    guest: {
      pill_title: 'Premi',
      earned_heading: 'Hai guadagnato <highlight>{{points}} punti</highlight> su questo ordine',
      worth_on_next: 'Valgono <strong>{{amount}}</strong> sul tuo prossimo ordine',
      ready_to_claim: 'Pronto da riscattare',
      next_order_discount: 'Sconto sul prossimo ordine',
      claim_cta: 'Riscatta i tuoi {{points}} pt — registrati gratis',
      claim_note: 'Ci vogliono 30 secondi · i punti vengono accreditati subito',
    },
  },
  buttons: {
    back_to_menu: 'Torna al menu',
    back_to_checkout: 'Torna al pagamento',
    contact_us: 'Contattaci al {{phone_number}}',
    try_again: 'Riprova',
  },
  loading: {
    processing_payment: 'Non abbandonare la pagina mentre elaboriamo il tuo pagamento',
  },
  success_messages: {
    order_placed: {
      title: '✅ Ordine effettuato!',
      description: 'Il tuo ordine è stato effettuato con successo.',
    },
  },
  error_messages: {
    failed_to_load: "Impossibile caricare l'ordine. Riprova.",
    payment_failed: 'Pagamento non riuscito, riprova',
  },
  load_failed: {
    title: 'Non siamo riusciti a caricare il tuo ordine',
    description:
      "Qualcosa è andato storto durante il caricamento dei dettagli del tuo ordine. Riprova. Se il problema persiste, contatta l'assistenza e ti aiuteremo subito.",
  },
};
